// Melding op het bord als het gezinsbord verwijderd gaat worden (0036). Turkse tegenhanger.
export const kioskPrivacyTr = {
    closingTitle: 'Bu pano {date} tarihinde kapanıyor',
    closingBody: 'Doğru değil mi? Bir ebeveyne sorun: uygulamada hâlâ durdurulabilir.',
};
//# sourceMappingURL=kioskPrivacy.tr.js.map